
import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    HostBinding,
    inject,
    input,
    model,
    output
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective,
    AbstractControl,
    ValidationErrors
} from '@angular/forms';
import { Store } from '@ngxs/store';
import { ZSelectComponent } from '@shared/components/form-components/z-select/z-select.component';
import {
    POSTerminalGraphQLSchemaActions,
    POSTerminalGraphQLSchemaSelectors,
    POSTerminalType,
    POSTerminalTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

@Component({
    selector: 'z-pos-terminals-select',

    templateUrl: './z-pos-terminals-select.component.html',
    styleUrl: './z-pos-terminals-select.component.scss',
    imports: [FormsModule, ReactiveFormsModule, ZSelectComponent],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZPosTerminalsSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZPosTerminalsSelectComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZPosTerminalsSelectComponent {
    @HostBinding('class') class?: string = 'flex flex-auto';
    mode = model<'edit' | 'view'>('view');
    label = input<string | undefined>('POS Τερματικά');
    showLabel = input<boolean | undefined>();
    showClear = input<boolean | undefined>();
    filter = input<boolean | undefined>();
    autocomplete = input<string | undefined>();
    id = input<string | undefined>();
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('_id');
    options = model<POSTerminalType[] | undefined>();
    placeholder = input<string | undefined>();
    POSTerminalChange = output<POSTerminalType>();
    store = inject(Store);
    constructor() {
        // this.store
        //   .select(VATCategoryGraphQLSchemaSelectors.FetchSelector('', ''))
        //   .pipe(takeUntilDestroyed())
        //   .subscribe((value) => {
        //     this.options.set(value?.data?.Fetch);
        //   });
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        if (this.options() == undefined)
            (
                this.store.selectSnapshot(
                    POSTerminalGraphQLSchemaSelectors.FetchSelector('', '')
                )?.data?.Fetch ?? []
            ).length == 0
                ? this.store
                      .dispatch(
                          new POSTerminalGraphQLSchemaActions.Fetch(
                              POSTerminalTypeQuery.GQLQuery(),
                              undefined
                          )
                      )
                      .subscribe(() => {
                          debugger;
                          this.options.set(
                              this.store.selectSnapshot(
                                  POSTerminalGraphQLSchemaSelectors.FetchSelector(
                                      '',
                                      ''
                                  )
                              )?.data?.Fetch
                          );
                      })
                : this.options.set(
                      this.store.selectSnapshot(
                          POSTerminalGraphQLSchemaSelectors.FetchSelector(
                              '',
                              ''
                          )
                      )?.data?.Fetch
                  );
    }

    modelChange(_id: string) {
        this.onModelChange(_id);
        const posTerminal = this.options()?.find((option) => option._id == _id);
        if (posTerminal != undefined) this.POSTerminalChange.emit(posTerminal);
    }
}
